import { Icon, List } from "@fluentui/react";
import React, { useState } from "react";
import { Utils } from "../../../common/views/Utils";
import { FileType, FileCategory, UploadPictureModel } from "../../../pictures/models/PictureModel";
import { createNewLineModel, NewLineModel } from "../../models/NewProductModel";
import LineInputView from "./LineInputView";

export type LineInputListProps = {
    lines: NewLineModel[];
    setLines: (newLines: NewLineModel[]) => void;
    onValueChange: <K extends keyof NewLineModel>(index: number, field: K, value: NewLineModel[K]) => void;
}

export default function LineInputListView({ lines, setLines, onValueChange }: LineInputListProps) {
    const [listHash, setListHash] = useState(Utils.getRandomKey());

    const onRenderCell = (line?: NewLineModel, index?: number) => {
        const width1 = Utils.getColumnWidth(1);
        const width11 = Utils.getColumnWidth(11);
        index = index ?? 0;

        if (!line) return <></>;

        return <div className="ms-Grid-row pv-10">
            <div className={width1}>
                <div style={{ paddingTop: 70 }}>
                    <Icon
                        iconName="Blocked2Solid"
                        className="icon firmed"
                        onClick={() => del(index ?? 0)} />
                </div>
            </div>
            <div className={width11}>
                <LineInputView form={line} index={index} onValueChange={onValueChange} />
            </div>

            <div className="ph-10"><hr /></div>
        </div>;
    }

    const del = (index: number) => {
        if (index < lines.length) {
            const line = lines[index];
            if (window.confirm("Would you like to delete " + line.name + "?")) {
                lines.splice(index, 1);
                setLines(lines);
            }
        }
    }

    const onLoadFile = (event: HTMLInputElement) => {
        if (event.files && event.files.length > 0) {
            loadDisplayPicture(event.files[0], event.files.length);
        }
    }

    const loadDisplayPicture = (file: File, length: number) => {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            let picture: UploadPictureModel = {
                type: FileType.image,
                category: FileCategory.normal,
                collageOrder: 99,
                bytes: [reader.result],
                imageUrl: [reader.result],
                file: file,
                id: 0,
                isPrimary: false,
                order: 0,
                length: 0,
            };

            let line = createNewLineModel();
            line.uploadPicture = picture;

            lines.push(line);

            setLines(lines);
            setListHash(Utils.getRandomKey());
        };
    }

    return <div className="p-15">
        <div className="font-bold">
            <span className="pr-20">Product Lines</span>

            <input
                id="uploadFile"
                name="uploadFile"
                type="file"
                onChange={(e) => onLoadFile(e.target)}
            />
        </div>

        <List key={listHash} items={lines} onRenderCell={onRenderCell} />
    </div>;
}